import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import CustomValuesPage from "PFModules/admin/custom_fields/custom_values/custom_values_page";
import React from "react";
import { Redirect, useParams } from "react-router-dom";

import { VALUE_TYPES_CONTENT_DISABLED } from "../custom_values.consts";
import { useCustomValuesPage } from "./use_custom_values_page";

const CustomValuesController = () => {
  const { id } = useParams();
  const { isLoaded, isFetching, customType, customValues, setPage, setCustomValuesParams, errors } =
    useCustomValuesPage(id);
  const WrappedDictionaries = usePageWrapper(CustomValuesPage);

  if (VALUE_TYPES_CONTENT_DISABLED.includes(customType?.value_type)) {
    return <Redirect to="/admin/custom_fields" />;
  }

  return (
    <WrappedDictionaries
      loading={!isLoaded}
      errors={errors}
      errorComponent={
        <NotFoundComponent
          message={"It looks like the Custom Values page page could not be loaded."}
          buttonMessage={"Please try to come back later"}
          buttonUrl="/admin/custom_fields"
        />
      }
      customType={customType}
      customValues={customValues}
      setPage={setPage}
      setCustomValuesParams={setCustomValuesParams}
      isFetching={isFetching}
    />
  );
};

export default CustomValuesController;
